module.exports = __webpack_public_path__ + "images/emoji/ocean.29f3ad544c3ff6fa4889.png";